import { paths } from '@mc/paths'
import type { DiscountModalContextValue } from './components/DiscountModalContext'

export const getIsGift = ({
  discount,
  pathname,
}: {
  discount: DiscountModalContextValue['discount']
  pathname: string
}) => {
  const isGiftPath =
    pathname &&
    (pathname.indexOf(paths.gift) > -1 ||
      pathname.indexOf(paths.manageGifts) > -1)

  return !!discount?.gift || !!isGiftPath
}
